var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8426 5.81531L10.9532 9.70381L7.06472 5.81531L5.76855 7.11147L9.65705 11L5.76855 14.8885L7.06472 16.1846L10.9532 12.2961L14.8426 16.1846L16.1388 14.8885L12.2503 11L16.1388 7.11147L14.8426 5.81531Z",
    fill: "#d31010",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.67e3feaf5de800235521447c31b8643c.svg";
export { ForwardRef as ReactComponent };